import React, { Component } from 'react'
import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';



import Dashboard from './Dashboard';
import RegForm from './Forms';
import Login from './Login';
import Profile from './Profile';
import Thankyou from './thankyou';
import NotFound from './NotFound';
import Default1 from './Default';
import Contact from './Contact'
import De from './De';

class App extends Component {


    render(){
        return(
          
            <Router>
            <Switch>
              
                 <Route exact path="/trial" component={Dashboard} />
                 <Route exact path="/trial/signup" component={RegForm} />
                 <Route exact path="/trial/login" component={Login} />
                 <Route exact path="/user-login/profile" component={Profile} />
                 <Route exact path="/trial/thankyou" component={Thankyou} />
                 <Route exact path="/trial/def" component={Default1} />
                 <Route exact path="/user-login/contact" component={Contact} />
                 <Route exact path="/trial/de" component={De} />
                 <Route component={NotFound} />

               
            </Switch>
             </Router>
         
       
        )
    }

}



export default App;